<template>
    <div class>
        <menus />
        <div class="main-content">
            <keep-alive>
                <router-view v-if="$route.meta.keepAlive" />
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive" />
        </div>
    </div>
</template>

<script>
import menus from './components/headerMenus';
export default {
    components: {
        menus,
    },
    props: {},
    data() {
        return {};
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {},
};
</script>
<style lang="scss" scoped>
.main-content {
    height: 100%;
    overflow: auto;
}
</style>
